module.exports = __webpack_public_path__ + "866e8def308836ca76ea1228f2bb034e.svg";